import { render, staticRenderFns } from "./fxrateSchedule.vue?vue&type=template&id=54a2a05f&scoped=true"
import script from "./fxrateSchedule.vue?vue&type=script&lang=js"
export * from "./fxrateSchedule.vue?vue&type=script&lang=js"
import style0 from "./fxrateSchedule.vue?vue&type=style&index=0&id=54a2a05f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a2a05f",
  null
  
)

export default component.exports